export default __webpack_public_path__ + "static/media/grandExam.d6a775f9.png";